// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import LoadingScreen from './components/loading-screen';
import ScrollToTop from './components/scroll-to-top';

// ----------------------------------------------------------------------

export default function App() {
  // No auth gate yet: `isInitialized` is hardcoded until a session check exists.
  const isInitialized = true; //
  return (
    <ThemeProvider>
      <ScrollToTop />
      {/* No <StyledChart /> here on purpose: it pulls react-apexcharts (~250 KB
          gzipped) into the bundle every public page downloads, and nothing on
          the public site renders a chart. A page that needs charts should
          import `useChart` from ./components/chart itself. */}
      {isInitialized ? <Router /> : <LoadingScreen />}
    </ThemeProvider>
  );
}